export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: 'AIzaSyDZR3OUW1GvqV_fNEYcC8llNpv3KGcccIc',
    authDomain: 'print2go-dev.firebaseapp.com',
    projectId: 'print2go-dev',
    storageBucket: 'print2go-dev.appspot.com',
    messagingSenderId: '490028498324',
    appId: '1:490028498324:web:bee954e1aee1bf1f8f2381',
    measurementId: 'G-WW8GVP3TNF'
  }
};
